import React from 'react'
import {Headings} from "../../Module_Exporter/Module_Exporter.js";
function Banner(props) {
  return (
    <section className={`pages_banner ${props.className}`} >
    <Headings aos="fade-left" text_aos="fade-right" cl="pages_Main_heading" h={props.h} title1={props.t1} title2={props.t2} text={props.text}  c={props.c} w={props.w}/>
   
  </section>
  )
}
Banner.defaultProps={
    t1:"Add",
    t2:"Title",
    h:"0.6rem",
    w:"50%",
    className:"defautBanner",
    c:"c2",
    text:"lorem lorem lorem lorem lorem loremlorem lorem loremlorem lorem loremlorem lorem lorem"
}
export default Banner